import { useRef, useCallback } from 'react';

interface UseDragDropOptions {
  containerRef: React.RefObject<HTMLDivElement | null>;
  onDrop: (files: FileList) => void;
}

export function useDragDrop({ containerRef, onDrop }: UseDragDropOptions) {
  const dragCounter = useRef(0);

  const handleDragEnter = useCallback(
    (e: React.DragEvent) => {
      e.preventDefault();
      dragCounter.current++;
      if (dragCounter.current === 1) {
        containerRef.current?.classList.add('drag-active');
      }
    },
    [containerRef]
  );

  const handleDragLeave = useCallback(
    (e: React.DragEvent) => {
      e.preventDefault();
      dragCounter.current--;
      if (dragCounter.current === 0) {
        containerRef.current?.classList.remove('drag-active');
      }
    },
    [containerRef]
  );

  const handleDragOver = useCallback((e: React.DragEvent) => {
    e.preventDefault();
  }, []);

  const handleDrop = useCallback(
    (e: React.DragEvent) => {
      e.preventDefault();
      dragCounter.current = 0;
      containerRef.current?.classList.remove('drag-active');
      onDrop(e.dataTransfer.files);
    },
    [containerRef, onDrop]
  );

  return { handleDragEnter, handleDragLeave, handleDragOver, handleDrop };
}
